import { Controller } from '@hotwired/stimulus'
import { renderStreamMessage } from '@hotwired/turbo'
import { patch, destroy } from '@rails/request.js'
import { flashResponseError, showFlashMessage } from '../../helpers'
import { elementsByDataSlot, elementsForAdjacentWeeks, refreshTurboFrames } from '../../helpers/calendar/turbo_frames'

export default class extends Controller {
  static targets = ['updateForm', 'deleteForm']

  async handleExtendShrinkEvent(event) {
    event.preventDefault()

    const button = event.currentTarget
    const form = button.closest('form')
    const entryElement = document.querySelector(`[data-calendar-entry-id="${button.dataset.entryId}"]`)

    try {
      const response = await patch(form.action, {
        headers: {
          'Accept': 'application/json'
        },
        body: new FormData(form)
      })

      if (response.ok) {
        const data = await response.json
        if (data.turbo_streams) {
          renderStreamMessage(data.turbo_streams)
        } else if (data.html && entryElement) {
          entryElement.outerHTML = data.html
        }

      } else {
        await flashResponseError(response, 'Failed to extend/shrink item. Please try again.')
      }
    } catch (error) {
      showFlashMessage('Network error. Please try again.')
    }
  }

  async handleDeleteEvent(event) {
    event.preventDefault()

    const button = event.currentTarget
    const form = button.closest('form')
    const entryElement = document.querySelector(`[data-calendar-entry-id="${button.dataset.entryId}"]`)

    const confirmed = await window.confirmationDialog("", form)

    if (!confirmed) {
      return
    }

    try {
      const response = await destroy(form.action, {
        headers: {
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        // A band bar has no slot and a behind-cap entry no element at all;
        // the server's term-row streams redraw either way.
        const slot = entryElement?.closest('[data-calendar--sortable-target="slot"]')
        entryElement?.remove()

        const data = await response.json
        if (data.turbo_streams) {
          renderStreamMessage(data.turbo_streams)
        }

        if (slot) {
          refreshTurboFrames(elementsForAdjacentWeeks(slot.dataset.sequence, slot.dataset.term, parseInt(slot.dataset.termWeek)))
        }
      } else {
        await flashResponseError(response, 'Failed to remove item. Please try again.')
      }
    } catch (error) {
      showFlashMessage('Network error. Please try again.')
    }
  }

  async handleHideUnhideEvent(event) {
    event.preventDefault()

    const button = event.currentTarget
    const form = button.closest('form')
    const entryElement = document.querySelector(`[data-calendar-entry-id="${button.dataset.entryId}"]`)

    try {
      const response = await patch(form.action, {
        headers: {
          'Accept': 'application/json'
        },
        body: new FormData(form)
      })

      if (response.ok) {
        const data = await response.json
        if (data.turbo_streams) {
          renderStreamMessage(data.turbo_streams)
        } else if (data.html && entryElement) {
          entryElement.outerHTML = data.html
        }

        const schedulableId = entryElement?.dataset.schedulableId
        if (schedulableId) {
          refreshTurboFrames(elementsByDataSlot('schedulable-id', schedulableId))
        }
      } else {
        await flashResponseError(response, 'Failed to update visibility. Please try again.')
      }
    } catch (error) {
      showFlashMessage('Network error. Please try again.')
    }
  }

}
